const UserType = {
  USER: 0,
  GHOST: 1
}
export default UserType
